import { type OfferShippingsV1 } from '@redteclab/api/clients/bully'

export const shippingAccessorGetShippingTypeCode = (
  deliveryOption: OfferShippingsV1,
): string | null | undefined => {
  if ('shippingTypeCode' in deliveryOption) {
    return deliveryOption.shippingTypeCode
  }

  return null
}
